import PropTypes from 'prop-types';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import Swal from 'sweetalert2';
import React, { useRef, useState, Suspense, lazy } from 'react';
import { Button } from '@mui/material';
import Spinner from '../../../../components/spinner/spinner';
import { OTP_OPTIONS, REQUEST_CUSTOM_EVENTS } from '../requestConstants';
import useReqGenOtp from '../hooks/useReqGenOtp';
import { formatPhone } from '../../../../utils/utils';
import { REQUEST_STATUS } from '../../../../utils/constants';
const ExecOtp = lazy(() => import('./samplecollectiondialog.component'));

const ExecActions = ({ requestDetails }) => {
  const captchRef = useRef(null);
  const [updating, setUpdating] = useState(false);
  const { loading: generating, requestOtp } = useReqGenOtp();

  const assignRequest = async () => {
    if (updating) { return; }
    try {
        setUpdating(true);
        const url = `${APIUtils.getAdminAPIEndpoint('exec-update-request')}/${requestDetails.uniqueId}`;
        const res = await httpClient.put(url, { status: REQUEST_STATUS.ACCEPTED }).then(res => res.data);
        if (res.status === 'success') {
          Swal.fire('Request assigned successfully!', '', 'success');
          document.dispatchEvent(new CustomEvent(REQUEST_CUSTOM_EVENTS.UPDATE_REQ_DETAILS, { detail: {...requestDetails, status: REQUEST_STATUS.ACCEPTED} }));
        }
    } catch (error) {
        console.error('Error assigning request:', error);
        if (error?.cause?.response?.data?.message) {
            Swal.fire('Sorry!', error.cause.response.data.message, 'error');
            return;
        }
        Swal.fire('Something Went Wrong!', '', 'error');
    } finally {
        setUpdating(false);
    }
  };

    const openOtpHandler = async () => {
      if (generating) return;
      try {
        const { patientNumber } = JSON.parse(requestDetails.patientInfo);
        const otpData = {phoneNumber: formatPhone(patientNumber), captchaElementOrID: captchRef.current};
        const {err, res} = await requestOtp(otpData);
        if (err) {
          console.log({err});
          if (err?.cause?.response?.data?.message) {
            Swal.fire('Sorry!', err.cause.response.data.message, 'error');
            return;
          }
          Swal.fire('Something Went Wrong!', '', 'error');
          return;
        }
        console.log({res});
        document.dispatchEvent(new CustomEvent(REQUEST_CUSTOM_EVENTS.OPEN_EXEC_OTP, { detail: {requestDetails, option: OTP_OPTIONS.SAMPLE_COLLECTION} }));
      } catch (error) {
        console.log({error});
        Swal.fire('Something Went Wrong!', '', 'error');
      }
    };

    const openSubmissionHandler = () => {
      document.dispatchEvent(new CustomEvent(REQUEST_CUSTOM_EVENTS.OPEN_EXEC_OTP, { detail: {requestDetails, option: OTP_OPTIONS.SAMPLE_SUBMISSION} }));
    };

    const acceptBtn = () => {
      const btnText = updating ? <>Accepting Request&nbsp;<Spinner /></> : 'Accept';
      return <Button variant="contained" onClick={assignRequest} disabled={updating}> {btnText} </Button>;
    };

    const collectSampleBtn = () => {
      const btnText = generating ? <>Sending OTP&nbsp;<Spinner /></> : 'Collect Sample';
      return (
        <>
          <Suspense fallback={<Spinner />}>
            <ExecOtp />
          </Suspense>
          <div ref={captchRef}></div>
          <Button variant="contained" onClick={openOtpHandler} disabled={generating}> {btnText} </Button>
        </>
      );
    };

    const submitSampleBtn = () => {
      const btnText = generating ? <>Sending OTP&nbsp;<Spinner /></> : 'Submit Sample';
      return (
        <>
          <Suspense fallback={<Spinner />}>
            <ExecOtp />
          </Suspense>
          <Button variant="contained" onClick={openSubmissionHandler}> {btnText} </Button>
        </>
      );
    };

    const showActions = () => {
      switch (requestDetails.status) {
        case REQUEST_STATUS.PENDING:
          return acceptBtn();
        case REQUEST_STATUS.ACCEPTED:
          return collectSampleBtn();
        case REQUEST_STATUS.SAMPLE_COLLECTED:
          return submitSampleBtn();
        default:
          return;
      }
    };

    return (
      <>
        {/* <Divider style={{marginBottom: '1rem'}} /> */}
        <div style={{textAlign: 'right'}}>
          {showActions()}
        </div>
      </>
    );
  };

  export default ExecActions;

  ExecActions.propTypes = {
    requestDetails: PropTypes.object.isRequired,
  };